import ClientsAxios from '../client-axios';
import { handlePostRequest } from './requestHandler';

const { COMMUNITY_HEALTH_CAMP_SERVER } = ClientsAxios;

export const FetchPincodeDetailsService = (payload: any) =>
    handlePostRequest<any>('pincode-mapping-details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CreateCampService = (payload: any) =>
    handlePostRequest<any>('campaign/store', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

export const UpdateCampService = (payload: any) =>
    handlePostRequest<any>('campaign/update', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

export const CampListingService = (payload: any) =>
    handlePostRequest<any>('campaign/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampDetailsService = (payload: any) =>
    handlePostRequest<any>('campaign/details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const GuestCampDetailsService = (payload: any) =>
    handlePostRequest<any>('guest/camp-details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const PendingActionReasonListService = (payload: any) =>
    handlePostRequest<any>('beneficiary-followup/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const BeneficiaryProcedureCreateService = (payload: any) =>
    handlePostRequest<any>('campaign/camp-procedure-store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampaignStatusUpdateService = (payload: any) =>
    handlePostRequest<any>('campaign/status-update', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampaignStatusCountService = (payload: any) =>
    handlePostRequest<any>('campaign/status-counts', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampaignAcceptRejectService = (payload: any) =>
    handlePostRequest<any>('campaign/accept-reject-coordinator', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchDieasesService = (payload: any) =>
    handlePostRequest<any>('diseases/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchGuestDiseasesService = (payload: any) =>
    handlePostRequest<any>('diseases/guest/listing', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchMedicineService = (payload: any) =>
    handlePostRequest<any>('medicine/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchConsultationMedicineService = (payload: any) =>
    handlePostRequest<any>('medicine/camp-medicine-details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchUserTypeListService = (payload: any) =>
    handlePostRequest<any>('user-type/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampaignOrganiserStoreService = (payload: any) =>
    handlePostRequest<any>('campaign/organizer-store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampaignCampUserListService = (payload: any) =>
    handlePostRequest<any>('campaign/camp-user', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchBeneficiaryDetailsMobileService = (payload: any) =>
    handlePostRequest<any>('beneficiary/verify-details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const MedicineListService = (payload: any) =>
    handlePostRequest<any>('medicine/medicine-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const MedicineStoreService = (payload: any) =>
    handlePostRequest<any>('medicine/medicine-store', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const MedicineStockUpdateService = (payload: any) =>
    handlePostRequest<any>('medicine/store-stock', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const FetchMedicineMasterListService = (payload: any) =>
    handlePostRequest<any>('medicine/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const TakeEscalationActionService = (payload: any) =>
    handlePostRequest<any>('escalation-action/store', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

export const FetchCampMediaService = (payload: any) =>
    handlePostRequest<any>('media-galley/list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const UploadCampMediaService = (payload: any) =>
    handlePostRequest<any>('media-galley/store', payload, COMMUNITY_HEALTH_CAMP_SERVER, { headers: { 'Content-Type': 'multipart/form-data' } });

export const FetchLocationInfomationService = (payload: any) =>
    handlePostRequest<any>('/location-list', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CampCoordinatorsService = (payload: any) =>
    handlePostRequest<any>('campaign/co-ordinators-details', payload, COMMUNITY_HEALTH_CAMP_SERVER);

export const CommonDeleteService = (url: string, payload: any) =>
    handlePostRequest<any>(url, payload, COMMUNITY_HEALTH_CAMP_SERVER);
